import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

export const ExpandableListItemSkeleton = () => (
  <li
    className="border-primary bg-primary group flex w-full min-w-0 flex-1 gap-x-4 rounded-xl px-6 py-4"
    data-testid="expandable-list-item-skeleton"
  >
    {/* 40px, matching the avatar the loaded row renders. */}
    <AvatarSkeleton size="lg" />

    <div className="flex w-full min-w-0 flex-1 flex-col gap-y-3">
      <div className="flex w-full min-w-0 flex-1 flex-row justify-between gap-y-3">
        <div className="min-w-0 flex-1">
          <div className="flex min-w-0 flex-col gap-y-3">
            <div className="flex flex-col gap-y-1">
              <Skeleton className="h-3.5 w-16" shape="pill" />
              <Skeleton className="h-2.5 w-1/2" shape="pill" />
            </div>

            <div className="flex items-center gap-1">
              <Skeleton className="h-2 w-7" shape="pill" />
            </div>
          </div>
        </div>
        <div className="flex w-fit items-start gap-2">
          <Skeleton className="h-9 w-[100px] rounded-full" shape="pill" />
        </div>
      </div>
    </div>
  </li>
);
